<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Сторис</strong>
                </CCardHeader>
                <CCardBody>
                    <StoriesTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                class="col-form-label"
                                sm="3">
                                Включено
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    class=""
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="stories.enabled" />
                            </CCol>
                        </CRow>

                        <CInput
                            v-model="stories.title"
                            horizontal
                            label="Название"
                            placeholder="Введите название сторис"/>

                        <CInput
                            v-model="stories.show_time"
                            horizontal
                            label="Время показа (милисекунды)"
                            placeholder="Введите время показа (милисекунды)" />

                        <CInput
                            v-model="stories.button_name"
                            horizontal
                            label="Название кнопки"
                            placeholder="Введите название кнопки"/>

                        <CInput
                            v-model="stories.color_button"
                            horizontal
                            label="Цвет кнопки (Например: #FFFFFF)"
                            placeholder="Введите цвет кнопки (Например: #FFFFFF)"/>

                        <CInput
                            v-model="stories.link"
                            horizontal
                            label="Ссылка"
                            placeholder="Введите ссылку на страницу, которая будет открываться при клике кнопку"/>

                        <StoriesPictures
                            :pictures="stories.pictures"
                            :stories-id="stories.id"
                            @pictures-update="fetch"
                        />
                    </CForm>

                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import StoriesTabLinks from '@/components/stories/StoriesTabLinks';
    import StoriesPictures from '@/components/stories/StoriesPictures';

    export default {

        name: 'StoriesEdit',

        components: {
            StoriesTabLinks,
            StoriesPictures
        },

        data: () => ({
            stories: {
                id: null,
                title: '',
                show_time: '',
                button_name: '',
                color_button: '',
                link: '',
                pictures: [],
                enabled: false,
            },
            isCreated: false,
        }),

        computed: {},

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;
                try {
                    const stories = await this.axios.get(`/stories/${id}`);
                    if (stories.data.id) {
                        this.stories = stories.data;
                        this.isCreated = true;
                    }
                } catch (error) { console.log(error); }
                this.stories.id = +id;
            },
            async save() {
                try {
                    if(this.stories.pictures.length > 5) {
                        this.$root.$emit('showError', 'Максимальное количество изображений 5');
                        return;
                    }
                    if(this.stories.pictures.length === 0) {
                        this.$root.$emit('showError', 'Добавьте изображения');
                        return;
                    }
                    if (!this.stories.title){
                        this.$root.$emit('showError', 'Введите название сторис');
                        return;
                    }
                    this.stories.show_time = +this.stories.show_time;
                    await this.axios.post(`/stories/${this.stories.id}`,this.stories);

                    this.goBack();
                } catch (error) {
                    console.log(error);
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router.push({ path: `/stories` });
            },
        },
    };
</script>
<style>
</style>
